import ListItem from "@/components/list-item"
import ListInput from "@/components/list-input"
import ListButton from "@/components/list-button"
import { faGripVertical, faTrash } from "@fortawesome/free-solid-svg-icons"
import { useTranslation } from "react-i18next"
import Space from "@/components/space"
import { DragDropContext, Droppable, Draggable, DropResult } from "react-beautiful-dnd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

type Props = {
  attributes: string[]
  editAttribute?: (key: string, val: string) => void
  removeAttribute?: (key: string) => void
  reorderAttributes: (newKeys: string[]) => void
}

export default function AccountOptionsRiskAttributes({
  attributes,
  editAttribute,
  removeAttribute,
  reorderAttributes
}: Props) {
  const { t } = useTranslation()

  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return
    const newAttributes = Array.from(attributes)
    const [moved] = newAttributes.splice(result.source.index, 1)
    newAttributes.splice(result.destination.index, 0, moved)
    reorderAttributes(newAttributes)
  }

  return (
    <div>
      {/* Liste draggable */}
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="risk-attributes">
          {(provided) => (
            <div className="flex-col w-full" ref={provided.innerRef} {...provided.droppableProps}>
              {attributes.map((key, index) => (
                <Draggable key={key} draggableId={key} index={index}>
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                      <ListItem>
                        <FontAwesomeIcon icon={faGripVertical} className="text-gray-400 my-auto mr-2 cursor-grab" />
                        {editAttribute ? (
                          <ListInput value={key} onEditEnd={(val: string) => editAttribute(key, val)} />
                        ) : (
                          key
                        )}
                        <Space />
                        {removeAttribute && (
                          <ListButton icon={faTrash} text={t("utils_delete")} onClick={() => removeAttribute(key)} />
                        )}
                      </ListItem>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  )
}
